import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useGetPermissionsQuery } from '../services/edgeApi';

export type CanProps = {
  type?: 'route' | 'component';
  can: string | string[];
  children?: React.ReactNode | React.ReactNode[];
};

export const Can: React.FC<CanProps> = (props) => {
  const {
    data: { rules: permissions } = {},
    error,
    isLoading,
  } = useGetPermissionsQuery(undefined);
  const { type = 'component', can, children } = props;

  const permissionsList = Array.isArray(can) ? can : [can];
  const grantedPermissionsSet = new Set(permissions || []);
  const neededPermissionsSet = new Set(permissionsList);
  const missingPermissions = neededPermissionsSet.difference(
    grantedPermissionsSet,
  );

  if (error) {
    console.error('PERMISSIONS ERROR', error);
    localStorage.removeItem('token');
    return null;
  }

  if (isLoading) {
    // console.log("PERMISSIONS LOADING")
    return null;
  }

  if (!permissions) {
    return null;
  }

  if (missingPermissions.size === 0) {
    // console.log("HAS THE PERMISSIONS")
    return type === 'route' ? <Outlet /> : children;
  } else {
    // console.log("NOT PERMITTED")
    // console.log(JSON.stringify(permissions))
    return type === 'route' ? <Navigate to="/" /> : <></>;
  }
};
